import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { FEATURED_CALCULATORS } from '../data/mock';

const CalculatorLayout = ({ title, subtitle, category, children, description, formulaNote }) => {
  const related = FEATURED_CALCULATORS.filter(c => c.category === category && c.name !== title).slice(0, 4);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
      {/* Breadcrumb */}
      <nav className="flex items-center gap-1.5 text-xs text-slate-500 mb-4">
        <Link to="/" className="flex items-center gap-1 hover:text-saffron-600">
          <Home className="w-3.5 h-3.5" /> Home
        </Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-slate-400">{category}</span>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-bharat-navy font-medium">{title}</span>
      </nav>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_300px] gap-6">
        <div className="min-w-0">
          {/* Header */}
          <div className="mb-5">
            <h1 className="font-display text-2xl md:text-3xl font-bold text-bharat-navy">{title}</h1>
            {subtitle && <p className="text-sm md:text-base text-slate-600 mt-1">{subtitle}</p>}
          </div>

          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 md:p-6">
            {children}
          </div>

          {description && (
            <div className="mt-6 bg-white rounded-xl border border-slate-200 p-5 md:p-6">
              <h2 className="font-display font-semibold text-lg text-bharat-navy mb-2">About this calculator</h2>
              <div className="text-sm text-slate-600 leading-relaxed space-y-2">
                {description}
              </div>
              {formulaNote && (
                <div className="mt-4 p-3 bg-saffron-50 border-l-4 border-saffron-500 rounded text-xs text-slate-700 font-mono">
                  {formulaNote}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Sidebar */}
        <aside className="space-y-5">
          <div className="bg-white rounded-xl border border-slate-200 p-5">
            <h3 className="font-display font-semibold text-bharat-navy text-sm mb-3">Related Calculators</h3>
            <div className="space-y-1">
              {related.map(c => {
                const Icon = c.icon;
                return (
                  <Link
                    key={c.id}
                    to={`/calculator/${c.id}`}
                    className="flex items-center gap-2.5 px-2.5 py-2 rounded-md hover:bg-saffron-50 text-slate-700 hover:text-saffron-700 transition-colors text-sm group"
                  >
                    <Icon className="w-4 h-4 text-saffron-500" />
                    <span>{c.name}</span>
                  </Link>
                );
              })}
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default CalculatorLayout;
